import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { date, styles } from 'yankees-react-utils';
import { store } from '../../../store';
import ReportCard from '../../../components/ReportCard';
import { Playlists, useOktaQuery } from '../../../data';
import VideoPlaylistButton from '../../../components/VideoPlaylistButton';
import { mapPlaylistFromApiPlaylist } from '../../../utils/playlists';
import PlayerAuthoredReportNote from '../../../components/Notes/PlayerAuthoredReportNote';
import usePlayerSelector from '../../../utils/usePlayerSelector';

const BPCard = ({ gameid, gamedate, playerid }) => {
    const { t: translate } = useTranslation();
    const userPlayer = usePlayerSelector();
    const { state: { user: loggedInUser } } = useContext(store);
    const roles = loggedInUser.Roles.map((r) => r.RoleName);
    // fetch playlists for this player and game
    const { data: playlists } = useOktaQuery(
        ['playlists', playerid, gameid],
        (t) => Playlists.getDatePlaylists(t, playerid, gamedate),
        { enabled: !!gameid && !!playerid },
    );
    const bpPlaylists = playlists?.filter((p) => p.PlayListCategory.Name === 'BP Sessions');
    return bpPlaylists?.length > 0 && (
        <ReportCard>
            <h2 className="text-start">{translate('baseball.batting-practice')}</h2>
            <div className="mt-1 d-flex flex-row">
                <div>
                    {bpPlaylists.map((playlist) => (
                        <div key={playlist.PlayListID}>
                            <VideoPlaylistButton
                                size="4em"
                                color={styles.theme.background.astronaut}
                                playlist={mapPlaylistFromApiPlaylist(playlist, translate, roles)}
                                icon="BP"
                                hideFilter
                            />
                        </div>
                    ))}
                </div>
                <div className="ms-4 flex-fill">
                    <PlayerAuthoredReportNote
                        className="h-100 mt-0"
                        type="mynt"
                        section="3"
                        player={userPlayer}
                        gameId={gameid}
                        compact
                        customTitleForModal={`Batting Practice Notes ${date(gamedate)}`}
                    />
                </div>
            </div>
        </ReportCard>
    );
};

BPCard.propTypes = {
    gameid: PropTypes.number.isRequired,
    gamedate: PropTypes.string.isRequired,
    playerid: PropTypes.number.isRequired,
};

export default BPCard;
